import { useCallback, useEffect, useState } from "react";
import { STATUS_EVENT } from "../types/events/status.js";
import { getStaticOptions } from "../utils/options.js";
/**
 * Listen to the queue status and automatically create a state with the errors.
 */ function useStatusErrors() {
    const [, setPreviousHash] = useState();
    const [errors, setErrors] = useState({});
    const applyErrors = useCallback((hash, list)=>setPreviousHash((previousHash)=>{
            if (previousHash !== hash) {
                setErrors(list);
                return hash;
            }
            return previousHash;
        }), []);
    const listener = useCallback(async ({ detail: { errors: { hash, list } } })=>{
        applyErrors(hash, list);
    }, []);
    useEffect(()=>{
        // Initial state
        const { hash, list } = getStaticOptions().errors;
        applyErrors(hash, list);
        document.addEventListener(STATUS_EVENT, listener);
        return ()=>{
            document.removeEventListener(STATUS_EVENT, listener);
        };
    }, []);
    return {
        errors
    };
}
export { useStatusErrors };
